<div class="flex flex-column h-full">
  <div class="flex flex-grow-1 relative">
    <div class="card-form absolute h-full w-full">
      <p-scrollPanel [style]="{ width: '100%', height: '100%' }">
        <form #dataForm="ngForm" (ngSubmit)="onSubmit()" class="px-4 py-3">
          <div class="flex flex-column lg:flex-row mb-4">
            <div class="flex flex-column flex-grow-1">
              <div
                class="p-float-label flex flex-column gap-2 mt-4 lg:mt-0 mb-4"
              >
                <p-dropdown
                  id="city"
                  name="city"
                  [options]="data.sources['city'].data"
                  [(ngModel)]="form.city_id"
                  [filter]="true"
                  appendTo="body"
                  [optionValue]="data.sources['city'].key"
                  [optionLabel]="data.sources['city'].label"
                  [required]="true"
                  class="ng-dirty"
                  placeholder="{{ 'FORM.SELECT-A-F' | translate }} {{
                    ('CORE.CITY' | translate).toLowerCase()
                  }}"
                >
                </p-dropdown>
                <label for="group">{{ "CORE.CITY" | translate }}</label>
              </div>

              <div
                class="p-float-label flex flex-column gap-2 mt-4 lg:mt-0 mb-4"
              >
                <p-dropdown
                  id="wall"
                  name="wall"
                  [options]="data.sources['wall'].data"
                  [(ngModel)]="form.wall_id"
                  [filter]="true"
                  appendTo="body"
                  [optionValue]="data.sources['wall'].key"
                  [optionLabel]="data.sources['wall'].label"
                  [required]="true"
                  class="ng-dirty"
                  placeholder="{{ 'FORM.SELECT-A-F' | translate }} {{
                    ('CORE.WALL' | translate).toLowerCase()
                  }}"
                >
                </p-dropdown>
                <label for="group">{{ "CORE.WALL" | translate }}</label>
              </div>

              <div
                class="p-float-label flex flex-column gap-2 mt-4 lg:mt-0 mb-4"
              >
                <p-dropdown
                  id="eps"
                  name="eps"
                  [options]="data.sources['eps'].data"
                  [(ngModel)]="form.eps_id"
                  [filter]="true"
                  appendTo="body"
                  [optionValue]="data.sources['eps'].key"
                  [optionLabel]="data.sources['eps'].label"
                  [required]="true"
                  class="ng-dirty"
                  placeholder="{{ 'FORM.SELECT-A-F' | translate }} {{
                    ('CORE.EPS' | translate).toLowerCase()
                  }}"
                >
                </p-dropdown>
                <label for="group">{{ "CORE.EPS" | translate }}</label>
              </div>
              <div
                class="p-float-label flex flex-column gap-2 mt-4 lg:mt-0 mb-4"
              >
                <p-calendar
                  id="date_"
                  name="date_"
                  [(ngModel)]="form.date_"
                  dateFormat="yy-mm-dd"
                  class="w-100 ng-dirty"
                  inputStyleClass="w-100"
                  appendTo="body"
                  [required]="true"
                ></p-calendar>
                <label for="group">{{ "FORM.DATE" | translate }}</label>
              </div>
              <div
                class="p-float-label flex flex-column gap-2 mt-4 lg:mt-0 mb-4"
              >
                <input
                  pInputText
                  id="title"
                  name="title"
                  class="ng-dirty"
                  aria-describedby="title-help"
                  [(ngModel)]="form.phone"
                  maxlength="100"
                  required
                />
                <label for="group">{{ "CORE.PHONE" | translate }}</label>
              </div>
            </div>
          </div>
        </form>
      </p-scrollPanel>
    </div>
  </div>
</div>
